var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as Approved } from '../../assets/images/global/calendar-check-gray.svg';
import { ReactComponent as Available } from '../../assets/images/global/circle-stroke.svg';
import { ReactComponent as Blocked } from '../../assets/images/global/block.svg';
import { ReactComponent as Canceled } from '../../assets/images/global/canceled.svg';
import { ReactComponent as Confirmed } from '../../assets/images/global/calendar-check.svg';
import { ReactComponent as Done } from '../../assets/images/global/done.svg';
import { ReactComponent as WaitingApprove } from '../../assets/images/global/clock.svg';
import { ReactComponent as Lost } from '../../assets/images/global/patient-cancel.svg';
import { ReactComponent as NotApprovedByInsurance } from '../../assets/images/global/close-cross-circle.svg';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import PhysicianScheduleCardAPI from './physician-schedule-card-api';
import React, { Component } from 'react';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import './physician-schedule-card.css';
import { ScheduleStatus } from './schedule-status';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let PhysicianScheduleCard = class PhysicianScheduleCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { establishmentCode, establishmentName, onClick, personName, scheduleDate, scheduleEndTime, scheduleStartTime, scheduleStatusCode, scheduleTypeDescription, statusItem, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        establishmentCode,
                        establishmentName,
                        onClick,
                        personName,
                        scheduleDate,
                        scheduleEndTime,
                        scheduleStartTime,
                        scheduleStatusCode,
                        scheduleTypeDescription,
                        statusItem,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderIcon(scheduleStatusCode) {
        switch (scheduleStatusCode) {
            case ScheduleStatus.AVAILABLE:
                return React.createElement(Available, null);
            case ScheduleStatus.DONE:
                return React.createElement(Done, null);
            case ScheduleStatus.CANCELED:
                return React.createElement(Canceled, null);
            case ScheduleStatus.LOST:
                return React.createElement(Lost, null);
            case ScheduleStatus.WAITING_APPROVE:
                return React.createElement(WaitingApprove, null);
            case ScheduleStatus.NOT_APPROVED_BY_INSURANCE:
                return React.createElement(NotApprovedByInsurance, null);
            case ScheduleStatus.CONFIRMED_BY_CLIENT:
                return React.createElement(Confirmed, null);
            case ScheduleStatus.APPROVED:
                return React.createElement(Approved, null);
            default:
                return React.createElement(Blocked, null);
        }
    }
    renderIndicatorColorStatus() {
        const { scheduleStatusCode } = this.props;
        let statusColor = '';
        switch (scheduleStatusCode) {
            case ScheduleStatus.DONE:
            case ScheduleStatus.CONFIRMED_BY_CLIENT:
                statusColor = 'c-physician-schedule-card__done';
                break;
            case ScheduleStatus.CANCELED:
            case ScheduleStatus.LOST:
                statusColor = 'c-physician-schedule-card__canceled';
                break;
            case ScheduleStatus.AVAILABLE:
            case ScheduleStatus.WAITING_APPROVE:
            case ScheduleStatus.NOT_APPROVED_BY_INSURANCE:
            case ScheduleStatus.APPROVED:
                statusColor = 'c-physician-schedule-card__pending';
                break;
            default:
                statusColor = 'c-physician-schedule-card__blocked';
                break;
        }
        return (React.createElement("div", { className: `c-physician-schedule-card__indicator-color ${statusColor}` }));
    }
    formatStartTime(startTime, endTime) {
        return `${startTime} - ${endTime}`;
    }
    renderContent() {
        const { scheduleTypeDescription, scheduleEndTime, scheduleStartTime, scheduleStatusCode, establishmentName, personName } = this.props;
        const icon = this.renderIcon(scheduleStatusCode);
        return (React.createElement("div", { className: 'c-physician-schedule-card__content' },
            React.createElement("div", { className: 'c-physician-schedule-card__content-left' },
                React.createElement("span", null, this.formatStartTime(scheduleStartTime, scheduleEndTime)),
                React.createElement("span", { className: 'c-physician-schedule-card-title' }, personName),
                React.createElement("span", { className: 'c-physician-schedule-card-subtitle' },
                    scheduleTypeDescription,
                    " | ",
                    establishmentName)),
            React.createElement("div", { className: 'c-physician-schedule-card__content-right' }, icon)));
    }
    renderField() {
        return (React.createElement(React.Fragment, null,
            this.renderIndicatorColorStatus(),
            this.renderContent()));
    }
    render() {
        const legends = [
            {
                color: 'signal-green-60',
                icon: React.createElement(Done, null),
                label: MessageService.translate('label.attended'),
                value: MessageService.translate('label.attended')
            },
            {
                color: 'signal-orange-45',
                icon: React.createElement(Canceled, null),
                label: MessageService.translate('tws.label-canceled'),
                value: MessageService.translate('tws.label-canceled')
            },
            {
                color: 'signal-orange-45',
                icon: React.createElement(Lost, null),
                label: MessageService.translate('tws.label-lost'),
                value: MessageService.translate('tws.label-lost')
            },
            {
                color: 'signal-orange-45',
                icon: React.createElement(WaitingApprove, null),
                label: MessageService.translate('tws.label-insurance-pending'),
                value: MessageService.translate('tws.label-insurance-pending')
            },
            {
                color: 'signal-green-60',
                icon: React.createElement(NotApprovedByInsurance, null),
                label: MessageService.translate('tws.label-insurance-not-appoved'),
                value: MessageService.translate('tws.label-insurance-not-appoved')
            },
            {
                color: 'signal-orange-45',
                icon: React.createElement(Confirmed, null),
                label: MessageService.translate('tws.label-confirmed'),
                value: MessageService.translate('tws.label-confirmed')
            },
            {
                color: 'signal-green-60',
                icon: React.createElement(Approved, null),
                label: MessageService.translate('tws.label-solicitation-approved'),
                value: MessageService.translate('tws.label-solicitation-approved')
            },
            {
                color: 'signal-green-60',
                icon: React.createElement(Available, null),
                label: MessageService.translate('tws.label-available'),
                value: MessageService.translate('tws.label-available')
            },
            {
                color: 'signal-green-60',
                icon: React.createElement(Blocked, null),
                label: MessageService.translate('tws.label-blocked'),
                value: MessageService.translate('tws.label-blocked')
            },
        ];
        const { scheduleStatusCode } = this.props;
        return (React.createElement(Card, { className: 'c-physician-schedule-card', onClick: () => this.handleClick(), selectionType: SelectionType.SINGLE, superscription: legends, uuid: generateUUID(), key: scheduleStatusCode, width: 12 }, this.renderField()));
    }
};
PhysicianScheduleCard = __decorate([
    AwesomeComponent({ api: PhysicianScheduleCardAPI, type: ComponentType.DATA_DISPLAY })
], PhysicianScheduleCard);
export default PhysicianScheduleCard;
//# sourceMappingURL=physician-schedule-card.js.map